const validate_microsoft_email = (email) => {
  if (email.length === 0) {
    return false
  }
  const regex = /^[a-zA-Z0-9._%+-]+@st\.neu\.edu\.vn$/
  return regex.test(email) // Kiểm tra email theo regex
}

const validate_email = (email) => {
  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
  return emailPattern.test(email) // Kiểm tra email theo regex
}

export { validate_microsoft_email, validate_email }
